"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProjectUserParamsThunk = exports.switchCurrentProject = exports.getProject = exports.getCurrentProject = exports.getProjects = exports.getCombinedMeThunk = void 0;
const actions_1 = require("../loader/actions");
const axios_1 = __importDefault(require("src/utils/axios"));
const actions_2 = require("./actions");
const thunk_1 = require("src/stores/applicationStore/tours/thunk");
const getCombinedMeThunk = (project_id = "") => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch((0, actions_1.setLoading)(true));
    try {
        const res = yield axios_1.default.get("/api/v1/users/profile/me/");
        if (res.status == 200) {
            yield dispatch((0, actions_2.setUser)(res.data));
            dispatch((0, exports.getProjects)());
            dispatch((0, thunk_1.fetchToursThunk)());
            dispatch(project_id ? (0, exports.getProject)(project_id) : (0, exports.getCurrentProject)());
        }
    }
    catch (error) {
        console.error;
    }
    finally {
        dispatch((0, actions_1.setLoading)(false));
    }
});
exports.getCombinedMeThunk = getCombinedMeThunk;
const getProjects = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const request = yield axios_1.default.get("/api/v1/app/project/");
    if (request.status == 200) {
        dispatch((0, actions_2.setProjects)(request.data));
        return request.data;
    }
    else {
        console.error;
    }
});
exports.getProjects = getProjects;
const getCurrentProject = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    return axios_1.default
        .get("/api/v1/app/current_project/profile/")
        .then((res) => {
        dispatch((0, actions_2.setCurrentProject)(res.data));
    })
        .catch(console.error);
});
exports.getCurrentProject = getCurrentProject;
const getProject = (projectID) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    return axios_1.default
        .get(`/api/v1/app/project/${projectID}/`)
        .then((res) => {
        dispatch((0, actions_2.setCurrentProject)(res.data));
    })
        .catch(console.error);
});
exports.getProject = getProject;
const switchCurrentProject = (data) => (dispatch, state) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch((0, actions_1.setLoading)(true));
    return axios_1.default
        .get("/api/v1/app/current_project/switch/", { data })
        .then(() => {
        const project = state.authReducer.projects.find((p) => (p.id = data.project));
        if (project) {
            dispatch((0, actions_2.setCurrentProject)(project));
        }
        else {
            console.error("switch project: project not found:", data.project);
        }
    })
        .catch(console.error)
        .finally(() => {
        dispatch((0, actions_1.setLoading)(false));
    });
});
exports.switchCurrentProject = switchCurrentProject;
const getProjectUserParamsThunk = (projectID) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    return axios_1.default
        .get(`/api/v1/app/project/${projectID}/user_params/`)
        .then((res) => {
        dispatch((0, actions_2.setProjectUserParams)(res.data));
    })
        .catch(console.error);
});
exports.getProjectUserParamsThunk = getProjectUserParamsThunk;
